export default {
  actions: {
    addSearchTags ({ commit }, tags) {
      commit('updateSearchTags', tags)
    },
    addSearchText ({ commit }, text) {
      commit('updateSearchText', text)
    }
  },
  mutations: {
    updateSearchTags (state, tags) {
      state.tags = []
      state.tags.push(...tags)
    },
    updateSearchText (state, text) {
      state.search = text
    }
  },
  state: {
    tags: [],
    search: ''
  },
  getters: {
    currentTags (state) {
      return state.tags
    },

    currentSearch (state) {
      return state.search
    }
  }
}
